<template>
  <section class="barocare-conci-product" id="Product">
    <div class="review-story">
      <div class="title-area" v-intersect>
        <div class="title-left">
          <h2 class="text-xl">
            폭 넓은 품목
            <br>합리적인 가격
          </h2>
        </div>
        <div class="title-right">
          <router-link to="/barocarenew/sub1" class="btn-go">전체 품목 확인하기<i
            class="ico-arrow-white"></i></router-link>
        </div>
      </div>
      <div class="slide-wrap" v-intersect>
        <ul class="review-list to-right">
          <li v-for="item in repeatedItems1" :key="item.id">
            <div class="blur-area">
              <span class="sub-text">{{ item.sub }}</span>
              <strong class="main-text">{{ item.main }}</strong>
              <div class="img-wrap">
                <img :src="item.image" :alt="item.main" />
              </div>
            </div>
            <a href="/barocarenew/sub1" class="btn-go">전체 품목 확인하기</a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ConciProduct',
  directives: {
    intersect: {
      // 요소가 DOM에 삽입될 때 호출됩니다.
      inserted(el) {
        const options = {
          root: null, // 뷰포트를 기본값으로 설정
          rootMargin: '0px', // 뷰포트의 마진은 0
          threshold: 0.1 // 10%가 보일 때 콜백이 실행
        };
        const callback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('visible');
            } else {
              el.classList.remove('visible');
            }
          });
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(el); // 해당 요소를 관찰 시작
      }
    }
  },
  data() {
    return {
      items1: [
        {
          id: 1,
          sub: '연속혈당측정기',
          main: '덱스콤G7',
          image: require('../../assets/pc_barocare_conci/img-product-1.png')
        },
        {
          id: 2,
          sub: '연속혈당측정기',
          main: '케어센스 에어',
          image: require('../../assets/pc_barocare_conci/img-product-2.png')
        },
        {
          id: 9,
          sub: '펜니들',
          main: 'Sol-M 펜니들 33G 4mm',
          image: require('../../assets/pc_barocare_conci/img-product-9.png')
        },
        {
          id: 3,
          sub: '연속혈당측정기',
          main: '프리스타일 리브레2',
          image: require('../../assets/pc_barocare_conci/img-product-3.png')
        },
        {
          id: 4,
          sub: '주사기',
          main: 'BD 울트라파인 인슐린 주사기',
          image: require('../../assets/pc_barocare_conci/img-product-4.png')
        },
        {
          id: 5,
          sub: '펜니들',
          main: '노보파인 펜니들',
          image: require('../../assets/pc_barocare_conci/img-product-5.png')
        },
        {
          id: 8,
          sub: '연속혈당측정기',
          main: '바로잰 핏',
          image: require('../../assets/pc_barocare_conci/img-product-8.png')
        },
        {
          id: 10,
          sub: '펜니들',
          main: 'Sol-M 펜니들 32G 4mm',
          image: require('../../assets/pc_barocare_conci/img-product-10.png')
        },
        {
          id: 6,
          sub: '시험지',
          main: '아큐첵 인스턴트 검사지',
          image: require('../../assets/pc_barocare_conci/img-product-6.png')
        },
        {
          id: 7,
          sub: '시험지',
          main: '케어센스N',
          image: require('../../assets/pc_barocare_conci/img-product-7.png')
        },
      ],
      repeatCount: 30
    }
  },
  computed: {
    repeatedItems1() {
      let result = [];
      for (let i = 0; i < this.repeatCount; i++) {
        this.items1.forEach(item => {
          result.push({
            ...item,
            id: `${item.id}-${i}`
          });
        });
      }
      return result;
    },
  },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciProduct.vue